import React, { Component } from 'react';
import {Button} from '@betareader/design-system';
import { withTranslation } from 'react-i18next';

const roles = {
  WRITER: 'WRITER',
  READER: 'READER',
  BOTH: 'BOTH'
};

export class RoleGetter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      role: props.initialValue
    };
  }

  setRole = (role) => {
    this.setState({ role }, () => {
      this.submit();
    });
  }

  submit = () => {
    const { role } = this.state;
    if (this.props.onUpdate) {
      this.props.onUpdate({ role })
    }
  }


  // render
  render() {
    const { t, updating } = this.props;
    const { role } = this.state;
    return (
      <React.Fragment>
        <h2>{t('RoleHeader')}</h2>
        <p>{t('RoleInfo')}</p>
        <div role='group' aria-label={t('RoleHeader')}
          style={{display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center'}}>
          <Button
            variant={role === roles.WRITER ? 'primary' : 'secondary'}
            aria-pressed={role === roles.WRITER}
            disabled={updating}
            onClick={() => this.setRole(roles.WRITER)}
          >{t('RoleWriter')}</Button>
          <Button
            variant={role === roles.READER ? 'primary' : 'secondary'}
            aria-pressed={role === roles.READER}
            disabled={updating}
            onClick={() => this.setRole(roles.READER)}
          >{t('RoleReader')}</Button>
          <Button
            variant={role === roles.BOTH ? 'primary' : 'secondary'}
            aria-pressed={role === roles.BOTH}
            disabled={updating}
            onClick={() => this.setRole(roles.BOTH)}
          >{t('RoleBoth')}</Button>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(RoleGetter)
